var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Image, Pressable, View } from 'react-native';
import { CancelIcon } from '../../../../icons';
import { getTestId, isValidObject } from '../../../../utils';
import { DynamicSvg } from '../../../dynamic-svg';
import { Loader } from '../../../loader';
import { Tooltip } from '../../../tooltip';
import { Typography } from '../../../typography';
import { getAppendPrependColorConfig, getPrependAppendItemStyles } from './InputPrependAppendItemStyles';
export var InputPrependAppendItem = props => {
  var _props$isPrepend = props.isPrepend,
    isPrepend = _props$isPrepend === void 0 ? false : _props$isPrepend,
    _props$showLoader = props.showLoader,
    showLoader = _props$showLoader === void 0 ? false : _props$showLoader,
    _props$isPressable = props.isPressable,
    isPressable = _props$isPressable === void 0 ? false : _props$isPressable,
    disabled = props.disabled,
    prefixIcon = props.prefixIcon,
    prefixText = props.prefixText,
    text = props.text,
    prependTextColor = props.prependTextColor,
    postfixIcon = props.postfixIcon,
    textAsAction = props.textAsAction,
    prefixImage = props.prefixImage,
    postfixImage = props.postfixImage,
    _onPress = props.onPress,
    style = props.style,
    readOnly = props.readOnly,
    _props$showClearButto = props.showClearButton,
    showClearButton = _props$showClearButto === void 0 ? false : _props$showClearButto,
    readOnlyOnPress = props.readOnlyOnPress,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'InputPrependAppendItem' : _props$testID,
    accessibilityProps = props.accessibilityProps,
    size = props.size,
    variantStyle = props.variantStyle,
    _showTooltip = props.showTooltip,
    tooltipProps = props.tooltipProps,
    _showTooltipOnMount = props.showTooltipOnMount,
    inputProps = props.inputProps,
    restProps = __rest(props, ["isPrepend", "showLoader", "isPressable", "disabled", "prefixIcon", "prefixText", "text", "prependTextColor", "postfixIcon", "textAsAction", "prefixImage", "postfixImage", "onPress", "style", "readOnly", "showClearButton", "readOnlyOnPress", "testID", "accessibilityProps", "size", "variantStyle", "showTooltip", "tooltipProps", "showTooltipOnMount", "inputProps"]);
  var _useState = useState(false),
    showTooltip = _useState[0],
    setShowTooltip = _useState[1];
  useEffect(() => {
    if (_showTooltip && _showTooltipOnMount) {
      setShowTooltip(true);
    }
  }, []);
  var INPUT_ICON_SIZE = 20;
  if (variantStyle != 'default') INPUT_ICON_SIZE = size == 'md' ? 24 : 32;
  var prependAppendItemStyles = getPrependAppendItemStyles();
  var containerProps = Object.assign(Object.assign({}, restProps), isPressable && {
    onPress: event => {
      _showTooltip && setShowTooltip(!showTooltip);
      _onPress === null || _onPress === void 0 ? void 0 : _onPress(event);
      readOnlyOnPress === null || readOnlyOnPress === void 0 ? void 0 : readOnlyOnPress();
    }
  });
  var PrependAppendImage = prependAppendImage => {
    return _jsx(Image, Object.assign({
      source: {
        uri: prependAppendImage === null || prependAppendImage === void 0 ? void 0 : prependAppendImage.imageUrl
      },
      resizeMode: "contain",
      style: [prependAppendItemStyles.itemRightSpacing, {
        height: INPUT_ICON_SIZE,
        width: INPUT_ICON_SIZE
      }]
    }, prependAppendImage === null || prependAppendImage === void 0 ? void 0 : prependAppendImage.imageProps));
  };
  if (!isPrepend && showClearButton) {
    var hidePointer = !isPressable || disabled || readOnly;
    return _jsx(Pressable, Object.assign({
      onPress: event => {
        _onPress === null || _onPress === void 0 ? void 0 : _onPress(event);
        readOnlyOnPress === null || readOnlyOnPress === void 0 ? void 0 : readOnlyOnPress();
      },
      style: [prependAppendItemStyles.container, hidePointer && prependAppendItemStyles.defaultCursor, style],
      accessible: true
    }, accessibilityProps, {
      children: _jsx(CancelIcon, Object.assign({
        fontSize: INPUT_ICON_SIZE,
        color: getAppendPrependColorConfig(inputProps, disabled, false, true).iconColor
      }, getTestId(testID, 'cancelIcon')))
    }));
  }
  if (!isPrepend && showLoader) {
    return _jsx(Container, Object.assign({}, props, {
      prependAppendItemStyles
    }, {
      children: _jsx(Loader, Object.assign({
        size: "md",
        color: getAppendPrependColorConfig(inputProps, disabled).iconColor,
        noPadding: true
      }, getTestId(testID, 'loader')))
    }));
  }
  var enableChildrenAccessibility = !isValidObject(accessibilityProps);
  var appendPrependWrapper = _ref => {
    var children = _ref.children;
    if (showTooltip) return _jsx(Tooltip, Object.assign({
      position: "bottom-end",
      offset: {
        x: 5,
        y: -15
      }
    }, tooltipProps, {
      isVisible: true,
      onClose: () => {
        if (tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.autoHide) {
          setShowTooltip(false);
        }
      },
      style: prependAppendItemStyles.tooltipStyle
    }, getTestId(testID, 'tooltip'), {
      children: children
    }));
    return _jsx(_Fragment, {
      children: children
    });
  };
  return _jsx(_Fragment, {
    children: appendPrependWrapper({
      children: _jsxs(Container, Object.assign({}, props, {
        containerProps,
        prependAppendItemStyles
      }, {
        children: [!!(prefixIcon === null || prefixIcon === void 0 ? void 0 : prefixIcon.iconName) && isPrepend && _jsx(DynamicSvg, Object.assign({
          iconName: prefixIcon === null || prefixIcon === void 0 ? void 0 : prefixIcon.iconName,
          fontSize: INPUT_ICON_SIZE,
          color: getAppendPrependColorConfig(inputProps, disabled, textAsAction, prefixIcon === null || prefixIcon === void 0 ? void 0 : prefixIcon.isActionable, prefixIcon === null || prefixIcon === void 0 ? void 0 : prefixIcon.iconColor).iconColor,
          style: prependAppendItemStyles.itemRightSpacing
        }, getTestId(testID, 'prefixIcon'))), !!(prefixImage === null || prefixImage === void 0 ? void 0 : prefixImage.imageUrl) && isPrepend && _jsx(PrependAppendImage, Object.assign({}, prefixImage)), !!prefixText && _jsx(Typography, Object.assign({
          text: prefixText,
          type: "body-single-line-sm",
          style: prependAppendItemStyles.itemRightSpacing,
          color: prependTextColor || getAppendPrependColorConfig(inputProps, disabled, textAsAction).textColor,
          accessible: enableChildrenAccessibility
        }, getTestId(testID, 'prefixText'))), !!text && _jsx(Typography, Object.assign({
          text: text,
          type: textAsAction ? 'button-text-tertiary-sm' : 'body-single-line-sm',
          style: prependAppendItemStyles.itemRightSpacing,
          color: getAppendPrependColorConfig(inputProps, disabled, textAsAction).textColor,
          accessible: enableChildrenAccessibility
        }, getTestId(testID, 'text'))), !!(prefixIcon === null || prefixIcon === void 0 ? void 0 : prefixIcon.iconName) && !isPrepend && _jsx(DynamicSvg, Object.assign({
          iconName: prefixIcon === null || prefixIcon === void 0 ? void 0 : prefixIcon.iconName,
          fontSize: INPUT_ICON_SIZE,
          color: getAppendPrependColorConfig(inputProps, disabled, textAsAction, prefixIcon === null || prefixIcon === void 0 ? void 0 : prefixIcon.isActionable, prefixIcon === null || prefixIcon === void 0 ? void 0 : prefixIcon.iconColor).iconColor,
          style: prependAppendItemStyles.itemRightSpacing
        }, getTestId(testID, 'prefixIconName'))), !!(prefixImage === null || prefixImage === void 0 ? void 0 : prefixImage.imageUrl) && !isPrepend && _jsx(PrependAppendImage, Object.assign({}, prefixImage)), !!(postfixIcon === null || postfixIcon === void 0 ? void 0 : postfixIcon.iconName) && _jsx(DynamicSvg, Object.assign({
          iconName: postfixIcon === null || postfixIcon === void 0 ? void 0 : postfixIcon.iconName,
          fontSize: INPUT_ICON_SIZE,
          color: getAppendPrependColorConfig(inputProps, disabled, textAsAction, postfixIcon === null || postfixIcon === void 0 ? void 0 : postfixIcon.isActionable, postfixIcon === null || postfixIcon === void 0 ? void 0 : postfixIcon.iconColor).iconColor
        }, getTestId(testID, 'postfixIconName'))), !!(postfixImage === null || postfixImage === void 0 ? void 0 : postfixImage.imageUrl) && _jsx(PrependAppendImage, Object.assign({}, postfixImage))]
      }))
    })
  });
};
var Container = props => {
  var children = props.children,
    containerProps = props.containerProps,
    isPressable = props.isPressable,
    disabled = props.disabled,
    readOnly = props.readOnly,
    readOnlyOnPress = props.readOnlyOnPress,
    prependAppendItemStyles = props.prependAppendItemStyles,
    testID = props.testID,
    accessibilityProps = props.accessibilityProps,
    style = props.style;
  var hidePointer = !isPressable || disabled || readOnly;
  var Component = !hidePointer || !!readOnlyOnPress ? Pressable : View;
  return _jsx(Component, Object.assign({}, containerProps, {
    style: [prependAppendItemStyles.container, hidePointer && prependAppendItemStyles.defaultCursor, style]
  }, getTestId(testID, 'container'), accessibilityProps, {
    accessible: true
  }, {
    children: children
  }));
};